export const environment = {
  production: true,
  firebase: {
    apiKey: 'AIzaSyB_OEoJDZOvSak5WZvIz70wvovvOmnpCEA',
    authDomain: 'prod-hitchd.firebaseapp.com',
    databaseURL: 'https://prod-hitchd.firebaseio.com',
    projectId: 'prod-hitchd',
    storageBucket: 'prod-hitchd-cdn',
    messagingSenderId: '799069079897',
    clouldFunctionHost: 'https://us-central1-prod-hitchd.cloudfunctions.net'
  },
  intercomApiKey: 'x3e3diap',
  stripePublicKey: 'pk_live_y4sqBdV7zz8DygAQkm9HsGfw',
  sentryId: 'https://bff2720ba9db4b6899a36a12cf466b58@hitchd-glitchtip-u45142.vm.elestio.app/4',
  stripeOAuthClientId: 'ca_ASgp1FSuN5Gcvg48nKYUOXVfQfgcSQ8n',
  imgCdnHost: 'https://hitchd.gumlet.io/uploads/',
  webUrl: 'https://www.hitchd.com/registry',
  payengine: {
    PAYENGINE_LOADER_CONFIG: {
      publicKey: 'pk_prod_0WgDMXm7ju2QevrE9cUCsCdCnodhpXO4',
      lightweight: true
    },
    BACKEND_SERVER: '',
    hmac: 'HMAC if enabled or using prod test123 prod'
  }
};




// WEBPACK FOOTER //
// ./src/environments/environment.ts